// extracted by mini-css-extract-plugin
export default {"error_page":"ErrorPage_error_page__1dwyw","not_found":"ErrorPage_not_found__SgUC6","animation":"ErrorPage_animation__Oj++y"};